export default {
  namespaced: true,
  state: {

  },
  getters: {

  },

  actions: {
    async login({dispatch, commit}, form) {
      await this._vm.$api.get('/sanctum/csrf-cookie');

      return form.submit('post', '/auth/login')
    },

    async register({dispatch, commit}, form) {
      await this._vm.$api.get('/sanctum/csrf-cookie');

      return form.submit('post', '/register/step-1')
    },

  },

  mutations: {

  },
};
